<template>
    <div id="app" ref="app">
      <!-- <div style="z-index: 999;" class="appTitle">
        <img src="../assets/other/fontImg.png" style="width: 60%;" alt="">
      </div> -->
        <div class="header">
            <div class="logo_img" style="z-index: 999;" ref="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="../assets/other/logo.png" >
                    </div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div style="font-size: 16px;color: white;font-weight: 800;" class="company_name">浙江毅星科技有限公司</div>
                    </div>
                </div>
            </div>
            <div id="menu_index" style="z-index: 999;">
                <el-menu  :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">首页</el-menu-item>
                    <el-menu-item index="2" class="header-title">公司简介</el-menu-item>
                    <el-menu-item index="3" class="header-title">核心产品</el-menu-item>
                    <el-menu-item index="4" class="header-title">公司资质</el-menu-item>
                    <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                </el-menu>
            </div>
            
        </div>
        
        <div class="aaaaaaa" ref="aaaaaaa">
          <vue-particles class="vue-particles" color="#8EB5C9" :particleOpacity="0.7" :particlesNumber="150" shapeType="star"
          :particleSize="4" linesColor="#8EB5C9" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
          :moveSpeed="5" :hoverEffect="true" hoverMode="repulse" :clickEffect="false" clickMode="push" ref="particles">
        </vue-particles>
      </div>
        <div class="container" style="clear: both;margin-top: 100vh;">
            <!-- <router-view></router-view> -->
            <div>
        <div ref="gsjj">
          <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                公司简介
            </div>
          </div>
          <div class="border_parent" >
            <el-row  style="color: #7d7d7d">
              <el-col :span="12">
                <div style="font-size: 18px;margin-bottom: 20px;">公司简介<span style="font-size: 13px;margin-left: 10px;">COMPANY PROFILE</span></div>
                <div style="line-height: 33px">
                  浙江毅星科技有限公司位于浙江省嘉兴市南湖区东栅街道信德园19幢7层702-1室，自2019年成立以来，致力于设计、建设和运营航天指控、训练、应用、运控、试验领域的地面配套、支持、模拟、仿真、测试、服务系统。
                </div>
                <div style="line-height: 33px">
                  经营范围：软件开发；机械设备研发；物联网技术研发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；人工智能理论与算法软件开发；人工智能应用软件开发；卫星遥感数据处理；数据处理服务；人工智能基础软件开发；
                  计算机系统服务；版权代理；信息安全设备销售；电子产品销售；计算机软硬件及辅助设备零售；计算机软硬件及辅助设备批发；机械设备租赁；机械设备销售；通信设备销售；软件销售；网络与信息安全软件开发；信息技术咨询服务；数字技术服务；
                  物联网技术服务；文具用品批发；文具用品零售；通讯设备销售；卫星通信服务（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）。
                </div>
              </el-col>
              <el-col :span="12" >
                <img style="width: 100%;height: 400px;margin-left: 100px;" src="../assets/other/gsjj.png" alt="">
              </el-col>
            </el-row>
          </div>
            <!-- <div class="border_parent">
              <el-row :gutter="10" style="display: flex;justify-content: space-between;margin-top: 10px;">
                <el-col :xs="12" :sm="12" :md="6">
                      <div class="border">
                          <div class="border_img_parent">
                              <img :src="images[0].img" class="img_border"/>
                          </div>
                          <div class="border_title">{{images[0].title}}</div>
                          <div class="border_content_one">{{images[0].content[0]}}</div>
                          <div class="border_content_two">{{images[0].content[1]}}</div>
                      </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="6">
                      <div class="border">
                          <div class="border_img_parent">
                              <img :src="images[1].img" class="img_border"/>
                          </div>
                          <div class="border_title">{{images[1].title}}</div>
                          <div class="border_content_one">{{images[1].content[0]}}</div>
                          <div class="border_content_two">{{images[1].content[1]}}</div>
                      </div>
                  </el-col>
                  <el-col :xs="12" :sm="12"  :md="6">
                      <div class="border" style="margin-right: 0">
                          <div class="border_img_parent">
                              <img :src="images[2].img" class="img_border"/>
                          </div>
                          <div class="border_title">{{images[2].title}}</div>
                          <div class="border_content_one">{{images[2].content[0]}}</div>
                          <div class="border_content_two">{{images[2].content[1]}}</div>
                      </div>
                  </el-col>
              </el-row>
          </div> -->
        </div>
        <div ref="hxcp">
          <div class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                核心产品
            </div>
          </div>
          <div class="product_mobile">
            <el-carousel :interval="3000" type="card" height="500px">
              <el-carousel-item v-for="(item,index) in images2" :key="index">
                <!-- <img :src="item.img" style="width: 100%;height: 100%;" alt=""> -->
                <el-image 
                  style="width: 100%; height: 100%"
                  :src="item.img" 
                  :preview-src-list="srcList">
                </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 公司资质-->
        <div id="公司资质" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                公司资质
            </div>
        </div>
        <div class="product_spec_parent">
            <div class="honnor">荣誉资质</div>
            <div class="honnor_photo">
              <img src="../assets/other/图片1.png" style="width: 12%;height: 80%;margin-left: 70px;" alt="">
              <img src="../assets/other/图片2.png" style="width: 12%;height: 80%;" alt="">
              <img src="../assets/other/图片3.png" style="width: 12%;height: 80%;" alt="">
              <img src="../assets/other/图片4.png" style="width: 12%;height: 80%;" alt="">
              <img src="../assets/other/图片5.png" style="width: 12%;height: 80%;" alt="">
              <img src="../assets/other/图片6.png" style="width: 12%;height: 80%;" alt="">
            </div>
        </div>
        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div style="width: 100%;height: 500px;margin-top: 15px;">
          <baidu-map 
            id="allmap" 
            :center="centerLagLat" 
            :zoom="18" 
            style="height: 100%; width: 100%"
            :scroll-wheel-zoom="true" 
            >
            <!-- <bm-scale anchor="BMAP_ANCHOR_TOP_LEFT"></bm-scale> -->
            <!--缩放控件右下角-->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <!--跳动标记-->
            <bm-marker :position="{ lng: 120.811869, lat: 30.726031 }" :dragging="false">
                <bm-label content="浙江毅星科技有限公司" 
                  :offset="{ width: 30, height: 0 }" />
            </bm-marker>
          </baidu-map>
        </div>
        <div class="footClass">
            <div style="display: flex; margin: 0 auto;max-width: 1200px;padding: 55px 10px;justify-content: space-around;">
              <div class="footItem">
                <img src="../assets/other/dizhi.png" style="width: 40px;height: 40px;margin-right: 25px;" alt="">
                <div style="margin-top: -10px;">
                  <div style="margin-bottom: 10px;">地址</div>
                  <div>浙江省嘉兴市南湖区东栅街道信德园19幢7层702-1室</div>
                </div>
              </div>
              <div class="footItem">
                <img src="../assets/other/dianhua.png" style="width: 40px;height: 40px;margin-right: 25px" alt="">
                <div style="margin-top: -10px;">
                  <div style="margin-bottom: 10px;">电话</div>
                  <div>0573-82053335/19957305005</div>
                </div>
              </div>
              <div class="footItem">
                <img src="../assets/other/youxiang.png" style="width: 40px;height: 40px;margin-right: 25px" alt="">
                <div style="margin-top: -10px;">
                  <div style="margin-bottom: 10px;">邮箱</div>
                  <div>yxkj@yxtech.vip</div>
                </div>
              </div>
            </div>
        </div>

    </div>
        </div>
        <div style="width: 100%;margin: auto;">
          <div style="background: rgba(0, 27, 48,.9);height:75px;color: white;text-align: center;line-height: 75px;font-size: 14px">
            <div style="width: 60%;margin: auto;">
              Copyright © 2024 版权所有 © 浙江毅星科技有限公司&emsp;&emsp;&emsp;
              <a style="text-decoration: none;color: white;" target="_blank" href="https://beian.miit.gov.cn">浙ICP备2024108877号-1</a>
            </div>
          </div>
        </div>
        <div id="back_to_top" v-show="isShow" ref="btn" @click="backTop" >
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img  src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'oukWFWRKCGktlhX25uFBpEt0nV4iayz1',  //个人手机号私人使用-July_zhengfj  oukWFWRKCGktlhX25uFBpEt0nV4iayz1
})
// import BmScale from 'vue-baidu-map/components/controls/Scale'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
    export default {
        name: "Layout",
        components:{
          // BmScale, //比例尺
          BmNavigation, //缩放
          BmMarker, //标记
        },
        data() {
            return {
              centerLagLat: { lng: 120.811869, lat: 30.726031 },
                activeIndex: '1',
                scroll: '',
                timer: '',
                images2: [
                    {
                        img: require('../assets/other/img1.png'),
                    },
                    {
                        img: require('../assets/other/img2.png'),
                    },
                    {
                        img: require('../assets/other/img3.png'),
                    },
                    {
                        img: require('../assets/other/img4.png'),
                    },
                ],
                srcList:[
                  require('../assets/other/img1.png'),
                  require('../assets/other/img2.png'),
                  require('../assets/other/img3.png'),
                  require('../assets/other/img4.png'),
                ],
                // images: [
                //     {
                //         img: require('../assets/other/数据分析.png'),
                //         title: "立足配套，走向自主",
                //         content: ["公司主要为军工国家队提供配套产品，提供盈利来源的同时使公司将大部分精力放在培养储备人才和提升专业能力上，为后续自主创新发展夯实基础。"]
                //     }, {
                //         img: require('../assets/other/用户构建.png'),
                //         title: "立足电子，辐射周边",
                //         content: ["电子卫星地面系统技术具有很强的商业价值，如电磁环境分析、信号分析等技术，对于通信、导航等领域应用可做适应性改造，辐射拓展电子领域系统应用场景。"]
                //     },
                //     {
                //         img: require('../assets/other/品牌渠道.png'),
                //         title: "立足军工，迈向融合",
                //         content: ["现阶段遥感和电子卫星领域相较通、导卫星领域商业化程度偏低，后续发展潜力大。遥感数据的共用以及大数据分析、计算机模拟仿真等诸多技术军民商通用，可为军民融合发展提供技术储备。"]
                //     }
                // ],
                isShow:false,
                scrollTopNum:'',
            };
        },
        watch:{
          scrollTopNum: function () {
            if (this.scrollTopNum > 50) {
              this.isShow = true;
            } else {
              this.isShow = false;
            }
          },
        },
        methods: {
          handleScroll() {
            let top = document.documentElement.scrollTop ||document.body.scrollTop ||window.pageYOffset;
            this.scrollTopNum = top;
          },
          handleSelect(key) {
            let apph = this.$refs.app.offsetHeight
            let hxcp = this.$refs.hxcp.offsetHeight
            let gsjj = this.$refs.gsjj.offsetHeight
              switch (key){
                  case '1':
                      break;
                  case '2':
                      window.scrollTo(0,apph)
                      break;
                  case '3':
                      window.scrollTo(0,apph + gsjj + 80)
                      break;
                  case '4':
                      window.scrollTo(0,apph + gsjj + hxcp + 80)
                      break;
                  case '5':
                      window.scrollTo(0,'3000')
                      break;
              }
          },
          backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
              this.timer = setInterval(() => {
                  let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                  let ispeed = Math.floor(-osTop / 3)
                  document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                  if (osTop === 0) {
                      clearInterval(this.timer)
                  }
              }, 30)
          },
          logoClick(){
              this.$router.push({name: "Index"});
          }
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll, true);
        },
        computed:{
          computeArrowImg() {
                    return require('../assets/other/arrow.png');
            }
        }
    }
</script>

<style scoped>
.aaaaaaa{
  background: url('../assets/other/background.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
}
#app{
  margin: 0;
  padding: 0;
  /* background: url('../assets/other/background.jpg') no-repeat; */
  background-size: 100% 100%;
  /* width: 1903px; */
  height: 100vh;
  /* display: flex;
  flex-direction: column */
}
#particles-js {
  position: absolute; 
  top: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;  
}

.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: transparent
}
.logo_img{
    float:left;
    margin-right: 20px;
    /* width: 13%; */
}
#back_to_top{
    position: fixed;
    bottom: 90px;
    right: 30px;
    cursor: pointer
}
.header-title{
    font-size: 1em;
}
.company_name{
    font-weight: normal;
    font-size: 1em;
}
.footer_font{
    font-size: 1em;
}
#menu_index{
    float: left; 
    /* width: 50%; */
    height: 100%
}
.el-menu{
  /* background: rgb(194, 194, 194); */
  background: transparent;
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  color: #409eff !important;
  background: transparent !important;
}
.el-menu--horizontal>.el-menu-item{
  color: white !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
  color: #409eff !important;
}
.appTitle{
  position: absolute;
  top: 50%;
  /* left: 45%; */
  color: white;
  font-size: 20px;
  text-align: center;
}
.header{
  margin: auto;
  /* width: 100%; */
  background: transparent;
  z-index: 9999;
  height: 65px;
  /*background: #F56C6C;*/
  /* position: fixed; */
  display: flex;
  padding-left: 400px;

  /* justify-content: center; */
}
#header-img{
    width: 50px;
    height: 50px;
    float: left;
    margin: auto;
}
.header-logo{
    height: 50px;
    width: 50px;
    align-self: center;
}
.header-important{
    float: left;
    margin-left: 6px;
    align-self: center;
}
.border_parent {
    width: 70%;
    margin: auto;
}
.solve {
    margin-top: 60px;
    margin-bottom: 20px
}
.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    /* height: auto; */
    width: 315px;
    height: 330px;
    line-height: 30px;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.border_img_parent {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}
.product_spec_title {
    margin-top: 30px;
    margin-bottom: 35px
}
.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: 260px;
}
.honnor{
  width: 50px;
  position: absolute;
  padding-top: 30px;
  height: 268px;
  color: white;
  line-height: 30px;
  font-size: 30px;
  font-weight: 10px;
  float: left;
  background-color: #0E357F;
  text-align: center;
  line-height: 50px;
} 
.honnor_photo {
  padding-top: 30px;
  border-top: 5px solid #E5E5E5;
  border-right: 5px solid #E5E5E5;
  border-bottom: 5px solid #E5E5E5;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 17px;
  text-align: center;
}
.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}
.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px
}
.about_me {
  display: flex;
  margin-top: 70px;
  justify-content: center;
  width: 100%;
}
.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: transparent;
}
.font_size_24 {
    font-size: 1.5em;
    font-weight: 800;
}
.footClass{
  width: 100%;
  background:url('../assets/other/foot.png') no-repeat;
  background-size: 100% 100%;
  margin: 0px auto;
  color: white;
  height: 170px;
}
.footItem{
  width: 300px;
  display: flex;
  font-size: 15px;
}
::v-deep .BMapLabel{
  color: black !important;
  font-size: 18px !important;
}
</style>